export default __webpack_public_path__ + "images/f8ab1784ec1f385004d8a34a87a81c3d.jpg";